export default "__VITE_ASSET__O1Bpk1C5__"